import * as React from 'react';
import injectSheet from 'react-jss';
import styleSheet from './styles';

interface CollegePillsProps {
  classes: any;
  pills: string[];
  removeCollegePill: (pill: any) => void;
}

const preventEventBubbling = (e: any) => {
  /*eslint no-unused-expressions: ["error", { "allowShortCircuit": true }]*/
  e && e.stopPropagation && e.stopPropagation();
  /*eslint no-unused-expressions: ["error", { "allowShortCircuit": true }]*/
  e && e.nativeEvent && e.nativeEvent.stopImmediatePropagation();
  /*eslint no-unused-expressions: ["error", { "allowShortCircuit": true }]*/
  e && e.preventDefault && e.preventDefault();
};

const CollegePills = ({
  pills,
  removeCollegePill,
  classes,
}: CollegePillsProps) => {
  return (
    <div className={classes.flexContainer}>
      {pills.map((pill: any) => {
        return (
          <span
            tabIndex={0}
            className={classes.flexPill}
            onKeyDown={e => {
              if (e.key !== 'Tab') {
                preventEventBubbling(e);
              }
              if (e.key === 'Enter' || e.key === ' ') {
                removeCollegePill({ value: pill.value });
              }
            }}
            onKeyUp={preventEventBubbling}
            onKeyPress={preventEventBubbling}
          >
            <span className={classes.pill}>{pill.label.split('(')[0]}</span>
            <span
              className={classes.close}
              onClick={() => removeCollegePill({ value: pill.value })}
            >
              <img src="images/UI/trailing-icon.svg" />
            </span>
          </span>
        );
      })}
    </div>
  );
};

export default injectSheet(styleSheet)(CollegePills);
